import script from "./TOCC_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./TOCC_Items.vue?vue&type=script&setup=true&lang=ts"

import "./TOCC_Items.vue?vue&type=style&index=0&id=6a4bce11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4bce11"]])

export default __exports__